import { FC } from 'react';
import '../../../styles/workplace.scss';

interface FullViewProps {
    primaryColor: string;
    doorStateText: string;
}

const DoorScreenManualStateView: FC<FullViewProps> = (props: FullViewProps) => {
    return (
        <div className="secondaryInformation" style={{ color: props.primaryColor }}>
            {props.doorStateText}
        </div>
    );
};

export default DoorScreenManualStateView;
